/* unplugin-vue-components disabled */import script from "./ButtonView.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonView.vue?vue&type=script&setup=true&lang=js"

import "./ButtonView.vue?vue&type=style&index=0&id=19b28cd8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b28cd8"]])

export default __exports__